// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2fwuo","alertIcon":"ConfirmModal_alertIcon__1sDRJ"};